import React from "react";
import Modal from "./Modal";
import { FaShareAlt, FaCopy, FaWhatsapp, FaFacebook, FaEnvelope, FaTwitter } from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import "./styles/ModalShareAd.css";

function getShareUrl(adId) {
  return `${window.location.origin}/goder/show/${adId}`;
}

function ShareChannel({ href, label, icon, onClick, external = true }) {
  const className = "share-ad-channel";

  if (href) {
    return (
      <a
        href={href}
        className={className}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        aria-label={label}
      >
        <span className="share-ad-channel__icon" aria-hidden="true">
          {icon}
        </span>
        <span className="share-ad-channel__label">{label}</span>
      </a>
    );
  }

  return (
    <button type="button" className={className} onClick={onClick} aria-label={label}>
      <span className="share-ad-channel__icon" aria-hidden="true">
        {icon}
      </span>
      <span className="share-ad-channel__label">{label}</span>
    </button>
  );
}

class ModalShareAd extends React.Component {
  state = {
    copied: false,
    canNativeShare: typeof navigator !== "undefined" && Boolean(navigator.share),
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ copied: false });
    }
  }

  getShareUrl = () => {
    const { ad } = this.props;
    return getShareUrl(ad?.Id || "");
  };

  getShareTitle = () => {
    return this.props.ad?.Name || "Godiway";
  };

  onCopyLink = async () => {
    const url = this.getShareUrl();

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("textarea");
        input.value = url;
        input.setAttribute("readonly", "");
        input.style.position = "absolute";
        input.style.left = "-9999px";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }

      this.setState({ copied: true });
      alertify.success(I18n.t("ad_share_copied"));
    } catch (error) {
      alertify.warning(I18n.t("try_later"));
    }
  };

  onNativeShare = async () => {
    const url = this.getShareUrl();
    const title = this.getShareTitle();

    try {
      await navigator.share({
        title,
        text: title,
        url,
      });
    } catch (error) {
      if (error?.name !== "AbortError") {
        console.log(error);
      }
    }
  };

  render() {
    const { isOpen, onClose } = this.props;
    const url = this.getShareUrl();
    const title = this.getShareTitle();
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const shareText = encodeURIComponent(`${title} ${url}`);

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={<Translate value="ad_share_title" />}
      >
        <div className="share-ad-modal">
          <div className="share-ad-modal-hero">
            <span className="share-ad-modal-icon" aria-hidden="true">
              <FaShareAlt />
            </span>
            <p className="share-ad-modal-title">{title}</p>
            <p className="share-ad-modal-hint">
              <Translate value="ad_share_hint" />
            </p>
          </div>

          <div className="share-ad-link-row">
            <input
              type="text"
              className="share-ad-link-input form-control"
              value={url}
              readOnly
              aria-label={I18n.t("ad_share_title")}
              onFocus={(event) => event.target.select()}
            />
            <button
              type="button"
              className={`share-ad-copy-btn${this.state.copied ? " is-copied" : ""}`}
              onClick={this.onCopyLink}
            >
              <FaCopy />
              <span>
                {this.state.copied ? (
                  <Translate value="ad_share_copied" />
                ) : (
                  <Translate value="ad_share_copy" />
                )}
              </span>
            </button>
          </div>

          <div className="share-ad-channels">
            {this.state.canNativeShare && (
              <ShareChannel
                label={I18n.t("ad_share_native")}
                icon={<FaShareAlt />}
                onClick={this.onNativeShare}
              />
            )}
            <ShareChannel
              href={`https://wa.me/?text=${shareText}`}
              label={I18n.t("ad_share_whatsapp")}
              icon={<FaWhatsapp />}
            />
            <ShareChannel
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
              label={I18n.t("ad_share_facebook")}
              icon={<FaFacebook />}
            />
            <ShareChannel
              href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
              label={I18n.t("ad_share_twitter")}
              icon={<FaTwitter />}
            />
            <ShareChannel
              href={`mailto:?subject=${encodedTitle}&body=${shareText}`}
              label={I18n.t("ad_share_email")}
              icon={<FaEnvelope />}
              external={false}
            />
          </div>

          <div className="share-ad-footer">
            <button type="button" className="share-ad-close-btn" onClick={onClose}>
              <Translate value="close" />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ModalShareAd;
